import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import View from "react-native-web/dist/exports/View";
export default React.forwardRef(function (props, ref) {
  return React.createElement(View, _extends({
    ref: ref,
    accessibilityRole: "button"
  }, props));
});